import React, { useCallback, useMemo } from "react";

import { JGAPCommonTree } from "@app/components/treeListCommon";
import { Case, CaseElse, Switch } from "@app/contexts";
import {
  newGroup,
  selectAllGroupsList,
  selectCurrentGroupsTreeList,
  selectGroupsTreeList,
  selectHasNewGroupDefined,
  setGroupTreeList,
  useAppDispatch,
  useAppSelector,
} from "@app/state";
import * as appConst from "@app/state/constants";
import { selectHostedOnboardings } from "@app/state/units/groups";
import { buildGroupsTreeList } from "@app/state/units/ui/groupstree";
import { useFxSelector } from "@app/statefx";

import "./groupstree.scss";
import { GroupListIco, GroupListTitle } from "./item";

export const GroupsTree = () => {
  const dispatch = useAppDispatch();
  const isNewGroupDefined = useAppSelector(selectHasNewGroupDefined);
  const selectedGroup = useAppSelector(selectCurrentGroupsTreeList);
  const groups = useAppSelector(selectAllGroupsList);
  const onboardings = useFxSelector(selectHostedOnboardings);
  const treeData = useMemo(
    () => buildGroupsTreeList(groups, onboardings),
    [groups, onboardings]
  );
  const bttnOptions = useMemo(() => {
    return {
      visible: !isNewGroupDefined || selectedGroup?.id !== -1,
    };
  }, [isNewGroupDefined, selectedGroup?.id]);

  const cellRender = useCallback(
    (e: any) => (
      <div>
        <Switch value={e.data.ptlCfgPage}>
          <Case when={appConst.GROUPS_PAGES.GROUP}>
            <GroupListIco e={e} />
            <span className="cell-perseed">{`${e.data.ptlDetail}`}</span>
            <span className="bat">{" | "}</span>
            <GroupListTitle e={e} />
            {e.data.ptlStatus ? (
              <span className="cell-status">{` | ${e.data.ptlStatus}`}</span>
            ) : null}
            {e.data.ptlReviewSummary ? (
              <span className="cell-review">{` | ${e.data.ptlReviewSummary}`}</span>
            ) : null}
          </Case>
          <Case when={appConst.GROUPS_PAGES.ENVIRONMENT}>
            <GroupListIco e={e} />
            <span className="bat">{e.data.ptlTitle}</span>
          </Case>
          <Case when={appConst.GROUPS_PAGES.DIRINFO}>
            <GroupListIco e={e} />
            <span className="bat">{e.data.ptlTitle}</span>
          </Case>
          <Case when={appConst.GROUPS_PAGES.BUILDER}>
            <GroupListIco e={e} />
            <span className="bat">{e.data.ptlTitle}</span>
          </Case>
          <CaseElse>
            <span>{""}</span>
          </CaseElse>
        </Switch>
      </div>
    ),
    []
  );

  const ptlSelectionChanged = useCallback((e: any) => {
    dispatch(setGroupTreeList(e.selectedRowsData[0]));
  }, []);

  const showNewGroup = useCallback((e: any) => {
    dispatch(newGroup());
  }, []);

  return (
    <JGAPCommonTree
      treeId={"groupsTreeList"}
      treeDataSelector={selectGroupsTreeList}
      currenNodeSelector={selectCurrentGroupsTreeList}
      cellRender={cellRender}
      treeSelectionChanged={ptlSelectionChanged}
      onAdd={showNewGroup}
      customAddOptions={bttnOptions}
      treeData={treeData}
    />
  );
};
